/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF, Html, useTexture, } from "@react-three/drei";
import ambience from "../public/sound/ambient-background.mp3";


export function Model(props) {



 


  const bakedTexture = useTexture('./TV/baked5.png');
  bakedTexture.flipY = false;
  const { nodes } = useGLTF("./TV/tv38.glb");

  return (
    <group {...props} dispose={null}>
      <mesh
        name="bakedNew"
        castShadow
        receiveShadow
        geometry={nodes.bakedNew.geometry}
        scale={[0.35, 0.35, 0.35]}
        onClick={(event) => {
          event.stopPropagation();
          // play();
          var iframe1 = document.getElementById('gameIframe');
          iframe1.style.display = 'block';

          var insBubble = document.querySelector('.instructionsBubble');
          insBubble.style.display = 'none';

          var keysMessage = document.querySelector('.keys');
          keysMessage.style.display = 'none';
        }}
      >
        <meshBasicMaterial map={bakedTexture} />
        <Html
          position={[-2.6, 0, 10]}
          wrapperClass="keyControls"
          className="keys">
          Use the WASD / Arrow keys to move
        </Html>
        <Html
          position={[2, 6, 0]}
          scale={[.75, .75, .75]}
          wrapperClass='instructions'
          className="instructionsBubble"
        >
          Click Me

        </Html>
        <Html transform
          wrapperClass='htmlScreen'
          distanceFactor={2}
          position={[0, 6.1, 1.5]}
          scale={[1, 1, 1]}
          occlude="blending"
          onClick={(e) => {

          }}
        >
          <iframe id='gameIframe'
            style={{ display: "none" }}
            src='https://paolapetitti123.github.io/CART411-Game/p5/game/index.html'
          />

        </Html>

      </mesh>

    </group>

  );
}

useGLTF.preload("/tv38.glb");
